// Config.
import Config 	from './config/config.js';

// Misc dependencies.
import createActionTypes from '../../../factories/actionTypes.js';

/**
 * <pre>
 * Sharing module Action Types.
 *
 * Summary of responsibilities:
 *
 *  - defines Redux action types specific to component
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 * @property {String} SHARE Dispatched when the user shares something.
 */
const ActionTypes = {
	SHARE: 'SHARE'
};

export default createActionTypes(ActionTypes, Config.stateKey);